import React, { useContext, useEffect, useState } from 'react'
import chevronRightWhite from '../images/svgs/chevron-right-white.svg'
import { css } from '@emotion/react'
import NavFacets from './nav-facets'
import NewsletterSignup from './newsletter-signup'
import Socials from './socials'
import useGetAllBuilderProducts from '../hooks/useGetAllBuilderProducts'
import useGetAllBuilderTheWave from '../hooks/useGetAllBuilderTheWave'
import ProductCard from './product-card'
import ArticleCard from './article-card'
import { Links as SynthesizersLinks } from './nav-synthesizers'
import { Links as AccessoriesLinks } from './nav-accessories'
import { Links as SoftwareStoreLinks } from './nav-software-store'
import { Links as TheWaveLinks } from './nav-the-wave'
import { SupportLinks } from './nav-support'
import { DownloadLinks } from './nav-support'
import NavAccount from './nav-account'
import { Index } from 'react-instantsearch'
import AppContext from './context'

const btnStyle = theme => css({
    fontFamily: theme.fonts.secondary,
    fontSize: 13,
    display: 'flex',
    gap: 8,
    justifyContent: 'space-between',
    color: 'white',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '4px 0',
    '&:hover': {
        cursor: 'pointer',
    }
})

const selectedStyle = theme => css({
    color: theme.colors.primary,
    fontWeight: 700,
})

const h6Style = theme => css({
    fontSize: 16,
    marginTop: 24,
    marginBottom: 16,
    paddingTop: 24,
    borderTop: `1px solid ${theme.colors.mutedDark}`,
    width: '100%',
})

const productGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 20,
}

const mainMenuStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 24
}

const subMenuStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: 24
}

const labelStyle = theme => css({
    fontFamily: theme.fonts.secondary,
    fontSize: 13,
    fontWeight: 700,
})

const hoverPrimary = theme => css({
    transition: 'color .5s ease',
    '&:hover': {
        color: theme.colors.primary
    }
})

const ChevronRightWhite = ({ style }) => <img
    src={chevronRightWhite}
    alt="chevron right"
    style={style ? style : { marginLeft: 'auto' }}
/>

export default function NavMobile() {
    const { overlay, subMenu, setSubmenu } = useContext(AppContext)
    const [height, setHeight] = useState(null)
    const closeSubMenu = () => setSubmenu('')
    
    const products = useGetAllBuilderProducts().filter(({ data }) => data.featured)
    const articles = useGetAllBuilderTheWave().filter(({ data }) => data.featured)

    let menu = <></>

    switch (subMenu) {
        case 'Synthesizers':
            menu = <>
                <div css={subMenuStyle}>
                    <button onClick={closeSubMenu} css={[btnStyle, selectedStyle]}>
                        <ChevronRightWhite style={{ transform: 'rotate(180deg)' }} />
                        {subMenu}
                    </button>
                    <SynthesizersLinks onClick={closeSubMenu} />
                    <NavFacets rootPath={subMenu} />
                </div>
                <h6 css={h6Style}>Featured Products</h6>
                <div css={productGridStyle}>
                    {products
                    .filter(({ data }) => data.categories.lvl0 === subMenu)
                    .slice(0, 2)
                    .map((product, i) => <ProductCard 
                        key={`${product.objectID}-${i}-mobile-product`}
                        product={product}
                    />)}
                </div>
            </>
            break;
        case 'Accessories':
            menu = <>
                <div css={subMenuStyle}>
                    <button onClick={closeSubMenu} css={[btnStyle, selectedStyle]}>
                        <ChevronRightWhite style={{ transform: 'rotate(180deg)' }} />
                        {subMenu}
                    </button>
                    <AccessoriesLinks onClick={closeSubMenu} />
                    <NavFacets rootPath={subMenu} />
                </div>
                <h6 css={h6Style}>Featured Products</h6>
                <div css={productGridStyle}>
                    {products
                    .filter(({ data }) => data.categories.lvl0 === subMenu)
                    .slice(0, 2)
                    .map((product, i) => <ProductCard
                        key={`${product.objectID}-${i}-mobile-product`}
                        product={product}
                    />)}
                </div>
            </>
            break;
        case 'Software Store':
            menu = <>
                <div css={subMenuStyle}>
                    <button onClick={closeSubMenu} css={[btnStyle, selectedStyle]}>
                        <ChevronRightWhite style={{ transform: 'rotate(180deg)' }} />
                        {subMenu}
                    </button>
                    <SoftwareStoreLinks onClick={closeSubMenu} />
                </div>
                <h6 css={h6Style}>Featured Products</h6>
                <div css={productGridStyle}>
                    {products
                    .filter(({ data }) => data.categories.lvl0 === 'Software Store')
                    .slice(0, 2)
                    .map((product, i) => <ProductCard
                        key={`${product.objectID}-${i}-mobile-product`}
                        product={product}
                    />)}
                </div>
            </>
            break;
        case 'The Wave':
            menu = <Index indexName='builder-moog-the-wave'>
                <div css={subMenuStyle}>
                    <button onClick={closeSubMenu} css={[btnStyle, selectedStyle]}>
                        <ChevronRightWhite style={{ transform: 'rotate(180deg)' }} />
                        {subMenu}
                    </button>
                    <TheWaveLinks onClick={closeSubMenu} />
                    <NavFacets rootPath={subMenu} />
                </div>
                <h6 css={h6Style}>Featured Articles</h6>
                <div css={productGridStyle}>
                    {articles
                    .filter(({ data }) => data.categories.lvl0 === subMenu)
                    .slice(0, 2)
                    .map((article, i) => <ArticleCard
                        key={`${article.objectID}-${i}-mobile-article`}
                        article={article}
                    />)}
                </div>
            </Index>
            break;
        case 'Support':
            menu = <>
                <div css={subMenuStyle}>
                    <button onClick={closeSubMenu} css={[btnStyle, selectedStyle]}>
                        <ChevronRightWhite style={{ transform: 'rotate(180deg)' }} />
                        {subMenu}
                    </button>
                    <h5 css={[labelStyle, { marginBottom: -8 }]}>Support</h5>
                    <SupportLinks onClick={closeSubMenu} />
                    <h5 css={[labelStyle, { marginBottom: -8, marginTop: 16, }]}>Downloads</h5>
                    <DownloadLinks onClick={closeSubMenu} />
                </div>
                <h6 css={h6Style}>Featured Products</h6>
                <div css={productGridStyle}>
                    {products.filter(({ data }) => data.categories.lvl0 === 'Synthesizers').slice(0, 2).map((product, i) => <ProductCard key={`${product.objectID}-${i}-mobile-product`} product={product} />)}
                </div>
            </>
            break;
        case 'Account':
            menu = <>
                <div css={subMenuStyle}>
                    <NavAccount />
                </div>
            </>
            break;
        default:
            menu = <>
                <div css={mainMenuStyle}>
                    <button onClick={() => setSubmenu('Synthesizers')} css={[btnStyle, hoverPrimary]}>
                        Synthesizers
                        <ChevronRightWhite />
                    </button>
                    <button onClick={() => setSubmenu('Accessories')} css={[btnStyle, hoverPrimary]}>
                        Accessories
                        <ChevronRightWhite />
                    </button>
                    <button onClick={() => setSubmenu('Software Store')} css={[btnStyle, hoverPrimary]}>
                        Software Store
                        <ChevronRightWhite />
                    </button>
                    <button onClick={() => setSubmenu('The Wave')} css={[btnStyle, hoverPrimary]}>
                        The Wave
                        <ChevronRightWhite />
                    </button>
                    <button onClick={() => setSubmenu('Support')} css={[btnStyle, hoverPrimary]}>
                        Support
                        <ChevronRightWhite />
                    </button>
                </div>
                <h6 css={h6Style}>Featured Products</h6>
                <div css={productGridStyle}>
                    {products
                    .filter(({ data }) => data.categories.lvl0 === 'Synthesizers')
                    .slice(0, 2)
                    .map((product, i) => <ProductCard
                        key={`${product.objectID}-${i}-mobile-product`}
                        product={product}
                    />)}
                </div>
            </>
            break;
    }

    useEffect(() => {
        if (typeof document === 'undefined') return
        setHeight(document.querySelector('#navbar').clientHeight)
    }, [])

    return (
        <div css={{
            display: 'flex',
            position: 'fixed',
            top: height,
            left: 0,
            zIndex: 1020,
            width: '100%',
            transitionDelay: overlay === 'Mobile' ? '0ms' : '250ms',
            height: overlay === 'Mobile' ? `calc(100vh - ${height}px)` : 0,
        }}>
            <div
                css={{
                    flexGrow: 1,
                    transition: 'all .5s ease',
                    backgroundColor: `rgba(255, 255, 255, ${overlay === 'Mobile' ? 0.15 : 0})`,
                    backdropFilter: 'blur(10px)',
                }} 
            />
            <div 
                id='mobile-overlay'
                css={{
                    position: 'absolute',
                    overflowY: 'auto',
                    padding: '24px 16px',
                    height: `calc(100vh - ${height}px - 48px)`,
                    width: `calc(100% - 32px)`,
                    maxWidth: 425,
                    background: 'black',
                    transition: 'all .5s ease',
                    right: overlay === 'Mobile' ? 0 : -(425 + 32),
                }}
            >
                {menu}
                <div css={h6Style}><NewsletterSignup /></div>
                <div css={{ marginTop: 24 }}><Socials /></div>
            </div>
        </div>
    )
}
